"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAIChatCompletionRequestSchema = exports.OpenAIChatCompletionMessageSchema = exports.OpenAIChatCompletionRequestMessageRoleSchema = exports.OpenAIChatCompletionRequestMessageRole = exports.OpenAIAppRequestSchema = exports.OpenAIChatResponseSchema = exports.OpenAIKeywordResponseSchema = exports.OpenAIResponseTypeSchema = exports.OpenAIResponseType = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
var OpenAIResponseType;
(function (OpenAIResponseType) {
    OpenAIResponseType["SEED_SUGGESTIONS"] = "S";
    OpenAIResponseType["KEYWORD_SUGGESTION"] = "K";
})(OpenAIResponseType = exports.OpenAIResponseType || (exports.OpenAIResponseType = {}));
exports.OpenAIResponseTypeSchema = (0, core_1.StringUnion)([...Object.values(OpenAIResponseType)], {
    title: "OpenAI response type",
    description: "The type of the response created from openai, indicating what level object relates to",
});
exports.OpenAIKeywordResponseSchema = (0, core_1.StrictObject)({
    keywords: typebox_1.Type.Array(ruby_1.KeywordSchema),
});
exports.OpenAIChatResponseSchema = (0, core_1.StrictObject)({
    message: typebox_1.Type.String(),
});
exports.OpenAIAppRequestSchema = (0, core_1.StrictObject)({
    appName: typebox_1.Type.String(),
    appRef: typebox_1.Type.Number(),
    numberOfKeywords: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
var OpenAIChatCompletionRequestMessageRole;
(function (OpenAIChatCompletionRequestMessageRole) {
    OpenAIChatCompletionRequestMessageRole["System"] = "system";
    OpenAIChatCompletionRequestMessageRole["User"] = "user";
    OpenAIChatCompletionRequestMessageRole["Assistant"] = "assistant";
})(OpenAIChatCompletionRequestMessageRole = exports.OpenAIChatCompletionRequestMessageRole || (exports.OpenAIChatCompletionRequestMessageRole = {}));
exports.OpenAIChatCompletionRequestMessageRoleSchema = (0, core_1.StringUnion)([...Object.values(OpenAIChatCompletionRequestMessageRole)], {
    title: "OpenAI role type",
    description: "The type of the role used by openai",
});
exports.OpenAIChatCompletionMessageSchema = (0, core_1.StrictObject)({
    role: exports.OpenAIChatCompletionRequestMessageRoleSchema,
    content: typebox_1.Type.String(),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.OpenAIChatCompletionRequestSchema = (0, core_1.StrictObject)({
    context: typebox_1.Type.String(),
    chat: typebox_1.Type.Array(exports.OpenAIChatCompletionMessageSchema),
    model: typebox_1.Type.Optional(typebox_1.Type.String()),
});
